import { useEffect, useState } from "react";
import { inkArray, strokePath, type Stroke } from "@worktools/shared";
import { useBoard } from "../sync/BoardContext";

export function InkLayer({ live }: { live: Stroke | null }) {
  const { doc } = useBoard();
  const [strokes, setStrokes] = useState<Stroke[]>(() => inkArray(doc).toArray());

  useEffect(() => {
    const array = inkArray(doc);
    const update = () => setStrokes(array.toArray());
    update();
    array.observe(update);
    return () => array.unobserve(update);
  }, [doc]);

  const all = live ? [...strokes, live] : strokes;

  return (
    <svg className="ink" data-canvas-background="true">
      {all.map((stroke) => (
        <path
          key={stroke.id}
          d={strokePath(stroke)}
          stroke={stroke.color}
          strokeWidth={stroke.width}
          strokeOpacity={stroke.tool === "marker" ? 0.35 : 1}
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
      ))}
    </svg>
  );
}
